import React, { useEffect, useState } from "react";
import apple from "../assets/svgs/apple.svg";
import { useDispatch } from "react-redux";
import { setShow } from "../redux/startSlice";

const STEP_MS = 350; // the bar fills a tenth this often: about 4 seconds in all

// The boot screen: the Apple logo and a progress bar, then the site appears (the screen goes once
// `show` is cleared). A click, tap or key press skips the wait.
const StartScreen = ({ device = "Mac" }) => {
  const [value, setValue] = useState(0);
  const disptach = useDispatch();
  const skip = () => disptach(setShow(false));

  useEffect(() => {
    const id = setTimeout(() => (value < 100 ? setValue(value + 10) : disptach(setShow(false))), STEP_MS);
    return () => clearTimeout(id);
  }, [value, disptach]);

  useEffect(() => {
    const onKey = () => disptach(setShow(false));
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [disptach]);

  return (
    <div className="boot no-select" onClick={skip}>
      <img src={apple} alt="" className="boot-logo" />
      <div
        className="boot-bar"
        role="progressbar"
        aria-label="Starting up"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={value}
      >
        <span style={{ width: `${value}%` }} />
      </div>
      <p className="boot-copy">
        You're about to explore my personal website, a replica of my {device}.
        Feel free to {device === "Mac" ? "click" : "tap"} around.
      </p>
    </div>
  );
};

export default StartScreen;
